import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraDashboardPage } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useMemo, useState } from 'react';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { PursuitFactsRail } from '../home/PursuitFactsRail';
import { PursuitHomeHeader, PursuitSetupHint } from '../home/PursuitHomeHeader';
import { PursuitThread } from '../home/PursuitThread';
import { buildPursuitKpis } from '../home/pursuitKpis';
import { LinkRecompeteDialog } from '../LinkRecompeteDialog';
import { usePursuitRecord } from '../PursuitRecordContext';
const KPI_TESTIDS = {
    decision: Testids.pursuitHome.kpiDecision,
    rfi: Testids.pursuitHome.kpiRfi,
    contract: Testids.pursuitHome.kpiContract,
    blackhat: Testids.pursuitHome.kpiBlackhat
};
/**
 * Pursuit Home (GRW-16): header, KPI strip, THREAD (growth_thread_v1) and the
 * facts rail, all from the header read model. Empty-first: a pursuit with no
 * gate, recompete link, RFI response or black hat shows no KPI strip, and
 * editors get the setup hint instead.
 */ export function PursuitHomePage() {
    const { captureProjectId, header, capabilities, correlationId } = usePursuitRecord();
    const metrics = useMemo(()=>buildPursuitKpis(header, new Date()), [
        header
    ]);
    const [linkOpen, setLinkOpen] = useState(false);
    if (!header) return null;
    const openLink = capabilities.canEdit ? ()=>setLinkOpen(true) : undefined;
    // capture.workspaceRoot stays on the record root (journeys wait for it on /capture/:id).
    return /*#__PURE__*/ _jsxs("div", {
        "data-capture-id": captureProjectId,
        "data-testid": Testids.capture.workspaceRoot,
        children: [
            /*#__PURE__*/ _jsx(SpecraDashboardPage, {
                "data-testid": Testids.pursuitHome.root,
                header: /*#__PURE__*/ _jsx(PursuitHomeHeader, {
                    correlationId: correlationId,
                    header: header,
                    setupHint: metrics.length === 0 && capabilities.canEdit ? /*#__PURE__*/ _jsx(PursuitSetupHint, {
                        captureProjectId: captureProjectId,
                        onLinkContract: ()=>setLinkOpen(true)
                    }) : undefined
                }),
                metrics: metrics.length > 0 ? {
                    metrics,
                    density: 'compact',
                    getItemTestId: (m)=>KPI_TESTIDS[m.id],
                    renderLink: renderRouterLink
                } : undefined,
                padding: "page",
                rail: /*#__PURE__*/ _jsx(PursuitFactsRail, {
                    header: header,
                    onLinkContract: openLink
                }),
                railLabel: "Pursuit details",
                railVariant: "record",
                workMaxWidth: "column",
                children: /*#__PURE__*/ _jsx(PursuitThread, {
                    captureProjectId: captureProjectId
                })
            }),
            capabilities.canEdit && linkOpen && /*#__PURE__*/ _jsx(LinkRecompeteDialog, {
                captureProjectId: captureProjectId,
                onOpenChange: setLinkOpen,
                open: linkOpen
            })
        ]
    });
}
